import { useMutation } from '@apollo/client'
import { setSubmitValidationCriteriaIsValid } from '../cache/submission-details'
import CHECK_SUBMIT_VALIDATION_CRITERIA from '../queries/mutations/check-submit-validation-criteria'

interface ICheckSubmitValidationCriteriaResponse {
  bjfSubmitDealInformationValidation: {
    isSuccess?: boolean
    errors?: {
      message: string
    }
  }
}

interface ICheckSubmitValidationCriteriaRequest {
  input: {
    bdId?: number
    employeeNumber?: number
    createdBy?: string
  }
}

export const useCheckSubmitValidationCriteria = () => {
  const [checkSubmitValidationCriteria, { data, loading, error }] = useMutation<
    ICheckSubmitValidationCriteriaResponse,
    ICheckSubmitValidationCriteriaRequest
  >(CHECK_SUBMIT_VALIDATION_CRITERIA, {
    fetchPolicy: 'no-cache',
  })
  const handleCheckSubmitValidationCriteria = async (
    dealId: number,
    employeeNumber: number,
    userEmail: string
  ) => {
    checkSubmitValidationCriteria({
      variables: {
        input: {
          bdId: dealId,
          employeeNumber,
          createdBy: userEmail,
        },
      },
    }).then((res) => {
      if (res?.data?.bjfSubmitDealInformationValidation) {
        const response = res.data.bjfSubmitDealInformationValidation

        if (response?.isSuccess) {
          setSubmitValidationCriteriaIsValid(true)
          return response.isSuccess
        }

        if (!response?.isSuccess) {
          setSubmitValidationCriteriaIsValid(false)
          return false
        }
      }
    })
  }

  return {
    checkSubmitValidationCriteria: handleCheckSubmitValidationCriteria,
    data,
    loading,
    error,
  }
}
